'use client'

import type { ReactNode } from 'react'

import { motion } from 'framer-motion'

import { Container } from '../layout/container'

type KineticAboutContactHeroProps = {
  statusLabel: string
  title: ReactNode
  subtitle: string
  beforeTitle?: ReactNode
  afterSubtitle?: ReactNode
}

export function KineticAboutContactHero({
  statusLabel,
  title,
  subtitle,
  beforeTitle,
  afterSubtitle,
}: KineticAboutContactHeroProps) {
  return (
    <section className="kinetic-hero-shell relative overflow-hidden pb-16 pt-28 md:pb-24">
      <div className="kinetic-hero-grid" aria-hidden />
      <Container className="relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75 }}
          className="mx-auto max-w-4xl text-center"
        >
          <div className="bg-kinetic-surface-container-high/50 mb-8 inline-flex items-center gap-3 border-l-2 border-kinetic-primary-container px-4 py-1.5">
            <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-kinetic-secondary-fixed">
              {statusLabel}
            </span>
            <span
              className="h-2 w-2 shrink-0 animate-pulse rounded-full bg-kinetic-secondary-fixed"
              aria-hidden
            />
          </div>
          {beforeTitle}
          <h1 className="kinetic-headline-glow font-headline text-5xl font-bold tracking-[-0.02em] text-white md:text-7xl lg:text-8xl lg:leading-[0.95]">
            {title}
          </h1>
          <p className="mx-auto mt-8 max-w-2xl text-lg font-light leading-relaxed text-kinetic-on-surface-variant md:text-xl">
            {subtitle}
          </p>
          {afterSubtitle}
        </motion.div>
      </Container>
    </section>
  )
}
